<main id="map-container" class="explore-map">
  <h1 class="sr-only">Explore Map</h1>
  <nav class="explore-map__nav">
    <ul class="list-unstyled">
      <li>
        <button
          class="btn btn-secondary btn-icon-only"
          type="button"
          id="availableDatasetsTrigger"
          data-bs-toggle="offcanvas"
          data-bs-target="#availableDatasets"
          aria-controls="availableDatasets"
          placement="end"
          ngbTooltip="Available Datasets"
          tooltipClass="map-tooltip"
          [openDelay]="1000"
        >
          <i class="bi bi-chevron-right" aria-label="Available Datasets"></i>
        </button>
      </li>
      <li>
        <button
          (click)="zoomIn()"
          class="btn btn-secondary btn-icon-only"
          [ngClass]="{ disabled: maxZoomReached }"
          type="button"
          placement="end"
          [ngbTooltip]="maxZoomReached ? 'Maximum Zoom Reached' : 'Zoom In'"
          tooltipClass="map-tooltip"
          [openDelay]="1000"
        >
          <i class="bi bi-plus-lg" aria-label="Zoom In"></i>
        </button>
      </li>
      <li>
        <button
          (click)="zoomOut()"
          class="btn btn-secondary btn-icon-only"
          [ngClass]="{ disabled: minZoomReached }"
          type="button"
          placement="end"
          [ngbTooltip]="minZoomReached ? 'Minimum Zoom Reached' : 'Zoom Out'"
          tooltipClass="map-tooltip"
          [openDelay]="1000"
        >
          <i class="bi bi-dash-lg" aria-label="Zoom Out"></i>
        </button>
      </li>
      <li>
        <button
          (click)="resetExtent()"
          class="btn btn-secondary btn-icon-only"
          type="button"
          placement="end"
          ngbTooltip="Reset Extent"
          tooltipClass="map-tooltip"
          [openDelay]="1000"
        >
          <i class="bi bi-arrows-fullscreen" aria-label="Reset Extent"></i>
        </button>
      </li>
      <li *ngIf="allowIdentify">
        <button
          (click)="toggleIdentifyFeature()"
          class="btn btn-secondary btn-icon-only"
          [ngClass]="{ active: identifyFeatureActive }"
          type="button"
          placement="end"
          ngbTooltip="Identify Feature"
          tooltipClass="map-tooltip"
          [openDelay]="1000"
        >
          <i class="bi bi-info-circle" aria-label="Identify Feature"></i>
        </button>
      </li>
      <li>
        <button
          (click)="toggleDatasetsByLocation()"
          class="btn btn-secondary btn-icon-only"
          [ngClass]="{ active: datasetsByLocationActive }"
          type="button"
          placement="end"
          ngbTooltip="Datasets at Location"
          tooltipClass="map-tooltip"
          [openDelay]="1000"
        >
          <i class="bi bi-geo-alt" aria-label="Datasets at Location"></i>
        </button>
      </li>
      <li *ngIf="allowOverlay">
        <button
          (click)="toggleOverlay()"
          class="btn btn-secondary btn-icon-only"
          [ngClass]="{ active: overlayVisible }"
          type="button"
          placement="end"
          [ngbTooltip]="overlayVisible ? 'Hide Overlay' : 'Show Overlay'"
          tooltipClass="map-tooltip"
          [openDelay]="1000"
        >
          <i class="bi bi-layers" aria-label="Show Overlay Layer"></i>
        </button>
      </li>
      <li *ngIf="mapServiceSlug === 'cadastral-all'">
        <button
          class="btn btn-secondary btn-icon-only"
          type="button"
          id="cadastralLayerPanelTrigger"
          data-bs-toggle="offcanvas"
          data-bs-target="#cadastralLayerPanel"
          aria-controls="cadastralLayerPanel"
          placement="end"
          ngbTooltip="Cadastral Layers"
          tooltipClass="map-tooltip"
          [openDelay]="1000"
        >
          <i class="bi bi-layers" aria-label="Cadastral Layers"></i>
        </button>
      </li>
      <li *ngIf="mapServiceSlug === 'open-gazetteer'">
        <button
          class="btn btn-secondary btn-icon-only"
          type="button"
          id="gazetteerLayerPanelTrigger"
          data-bs-toggle="offcanvas"
          data-bs-target="#gazetteerLayerPanel"
          aria-controls="gazetteerLayerPanel"
          placement="end"
          ngbTooltip="Gazetteer Layers"
          tooltipClass="map-tooltip"
          [openDelay]="1000"
        >
          <i class="bi bi-layers" aria-label="Gazetteer Layers"></i>
        </button>
      </li>
            <li *ngIf="mapServiceSlug === 'hvlsp'">
        <button
          class="btn btn-secondary btn-icon-only"
          type="button"
          id="hvlspLayerPanelTrigger"
          data-bs-toggle="offcanvas"
          data-bs-target="#hvlspLayerPanel"
          aria-controls="hvlspLayerPanel"
          placement="end"
          ngbTooltip="Select Theme"
          tooltipClass="map-tooltip"
          [openDelay]="1000"
        >
          <i class="bi bi-layers" aria-label="Gazetteer Layers"></i>
        </button>
      </li>
      <li *ngIf="activeMapProxyLayername && allowLegend">
        <button
          class="btn btn-secondary btn-icon-only"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#legend"
          aria-controls="legend"
          placement="end"
          ngbTooltip="View Legend"
          tooltipClass="map-tooltip"
          [openDelay]="1000"
        >
          <i class="bi bi-list-ul" aria-label="View Legend"></i>
        </button>
      </li>
    </ul>
  </nav>
  <app-gazetteer-search
    (selectedResult)="onSelectGazetteerResult($event)"
    (clearGazetteerResults)="onClearGazetteerResult()"
  ></app-gazetteer-search>
  <app-datasets-list
    [activeMapServiceSlug]="mapServiceSlug"
    [countryAtCoordinates]="countryAtCoordinates"
  ></app-datasets-list>
  <app-cadastral-layer-panel
    *ngIf="mapServiceSlug === 'cadastral-all'"
    [map]="map"
  ></app-cadastral-layer-panel>
  <app-gazetteer-layer-panel
    *ngIf="mapServiceSlug === 'open-gazetteer'"
    [map]="map"
  ></app-gazetteer-layer-panel>
  <app-hvlsp-layer-panel
    *ngIf="mapServiceSlug === 'hvlsp'"
    [map]="map"
  ></app-hvlsp-layer-panel>
  <span
    class="d-none"
    data-bs-toggle="offcanvas"
    data-bs-target="#identifyFeature"
    (click)="onIdentifyTriggerClick($event)"
    id="identifyFeatureHiddenTrigger"
  >
  </span>
  <div
    *ngIf="identifyLoading"
    class="position-absolute loading-spinner d-flex align-items-center alert alert-secondary p-2 rounded shadow"
    role="alert"
  >
    <div class="spinner-border me-3" role="status"></div>
    Loading...
  </div>
  <app-identify-feature [featuresInfo]="featuresInfo"></app-identify-feature>
  <app-legend
    [activeMapProxyLayername]="activeMapProxyLayername"
    [mapServiceName]="mapService.name"
    *ngIf="activeMapProxyLayername && allowLegend"
  ></app-legend>
  <span class="layer-name" [innerHTML]="attribution"></span>
</main>
